<template>
<div class="Body">
  <HeaderGestion/>
  <SubHeaderGestion nombreGestion="Publicaciones periódicas"/>
  <FormPubPer/>
</div>
</template>

<script>
import HeaderGestion from '../components/HeaderGestion.vue'
import SubHeaderGestion from '../components/SubHeaderGestion.vue'
import FormPubPer from '../components/FormPubPer.vue'
export default {
  components: { HeaderGestion, SubHeaderGestion, FormPubPer },
  name: 'GesPubPer',
  data () {
    return {
      gestion: 'Gestión colecciones',
      show: 'Explorar colecciones'
    }
  },
  methods: {
    goToGestion () {
      this.$router.push('/menuColecciones')
    }
    // goToExplorar () {
    //  this.$router.push('/page2')
    // }
    // imgPort (portada) {
    //   this.vistaPortada = portada
    //   console.log(portada)
    // }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
